import { Preferences } from '@capacitor/preferences';

export async function set(key: string, value: any): Promise<void> {
  try {
    await Preferences.set({
      key: key,
      value: JSON.stringify(value),
    });
  } catch (error) {
    console.error(`Failed to save data for key "${key}":`, error);
    throw error;
  }
}
export async function get(key: string): Promise<any> {
  try {
    const item = await Preferences.get({ key: key });
    if (!item.value || item.value === '') {
      return null;
    }
    return JSON.parse(item.value);
  } catch (error) {
    console.warn(`Failed to parse JSON for key "${key}":`, error);
    // Entferne den ungültigen Wert aus den Preferences
    await Preferences.remove({ key: key });
    return null;
  }
}
export async function remove(key: string): Promise<void> {
  await Preferences.remove({
    key: key,
  });
}
